"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
Object.defineProperty(exports, "serialize", {
  enumerable: true,
  get: function get() {
    return _serialize["default"];
  }
});
var _jsan = _interopRequireDefault(require("jsan"));
var _serialize = _interopRequireDefault(require("./serialize"));
var _options = _interopRequireDefault(require("../constants/options"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _default(immutable, refs, customReplacer, customReviver) {
  return {
    stringify: function stringify(data) {
      return _jsan["default"].stringify(data, (0, _serialize["default"])(immutable, refs, customReplacer, customReviver).replacer, undefined, _options["default"]);
    },
    parse: function parse(data) {
      return _jsan["default"].parse(data, (0, _serialize["default"])(immutable, refs, customReplacer, customReviver).reviver);
    },
    serialize: _serialize["default"]
  };
}